import React from 'react';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, { Botao as BotaoForm, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import Modal from 'Component/Modal';
import Bibliografia from 'Interface/Bibliografias';
import { useAdicionarBibliografiaMutation } from 'View/Service/Default/Bibliografias';

interface Props {
  exibir: boolean;
  unidadeDeAprendizagemId?: number;
  aoFechar: (estado: boolean) => void;
}

const regras = object({
  titulo: string().required('Obrigatório'),
  url: string().url('Deve ser uma url válida').nullable().optional(),
});

const Adicionar = ({
  exibir,
  aoFechar,
  unidadeDeAprendizagemId,
}: Props): React.ReactElement => {
  const toast = useToast();
  const [adicionarBibliografia] = useAdicionarBibliografiaMutation();

  const adicinar = async (dados: Bibliografia): Promise<void> => {
    try {
      await adicionarBibliografia({
        ...dados,
        unidade_de_aprendizagem_id: unidadeDeAprendizagemId,
      }).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      aoFechar(false);
    } catch (erro) {
      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <Modal exibir={exibir} aoFechar={aoFechar}>
      <Form onSubmit={adicinar} regras={regras}>
        <Campo name="titulo" rotulo="Título da bibliografia" />
        <Campo name="url" rotulo="URL" prefixar={<Icone nome="link" />} />
        <BotaoForm>Salvar</BotaoForm>
        <Botao ms onClick={() => aoFechar(false)} tema="light">
          Cancelar
        </Botao>
      </Form>
    </Modal>
  );
};

export default Adicionar;
